function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, `Asset 2`);

const SvgComponent = props => React.createElement("svg", _extends({
  viewBox: "0 0 16 15.7"
}, props), _ref, React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("polygon", {
  points: "6.23 11.11 2.82 14.5 2.82 11.11 0.5 11.11 0.5 0.5 15.5 0.5 15.5 11.11 6.23 11.11",
  style: {
    "fill": "none",
    "stroke": "#000",
    "strokeMiterlimit": 10
  }
}), React.createElement("line", {
  x1: 4.9,
  y1: 4.18,
  x2: 10.9,
  y2: 4.18,
  style: {
    "fill": "none",
    "stroke": "#000",
    "strokeMiterlimit": 10
  }
}), React.createElement("line", {
  x1: 4.9,
  y1: 7.29,
  x2: 10.9,
  y2: 7.29,
  style: {
    "fill": "none",
    "stroke": "#000",
    "strokeMiterlimit": 10
  }
}))));

export default __webpack_public_path__ + "static/media/icon-messages.6cd6ddc5.svg";
export { SvgComponent as ReactComponent };